import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Select, TextInput, Textarea, Loader, Text, Paper, Image, Input, Center, Checkbox, Fieldset, MultiSelect } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconPhotoPlus } from '@tabler/icons-react'
import { getAllProductsList } from '../../../services/products'
import { getAllBrandList } from '../../../services/brands'
import { getAllSupplierList } from '../../../services/supplier'
import { getCategorysList } from '../../../services/category'
import { getListUsers } from '../../../services/users'
import { getAllCountryList } from '../../../services/location'
import { getListUserMemberships } from '../../../services/users'
import { useDebouncedCallback } from '@mantine/hooks'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import { validation } from '../../../plugins/validation'
import { addAdminNews } from '../../../services/news'

const defaultTypeNotification = [
  {
    value: 'info',
    label: 'Info'
  },
  {
    value: 'product',
    label: 'Product'
  },
  {
    value: 'category',
    label: 'Category'
  },
  {
    value: 'brand',
    label: 'Brand'
  },
  {
    value: 'supplier',
    label: 'Supplier'
  },
]

const defaultTypeImageNotification = [
  {
    value: '',
    label: 'No Image'
  },
  {
    value: 'url',
    label: 'Image URL'
  },
  {
    value: 'upload',
    label: 'Upload New Image'
  },
]

const defaultVal = {
  label: 'info',
  title: '',
  notes: '',
  onclick_url: '',
  onclick_id: null,
}

const formValidation = {
  label: {
    isError: false,
    message: ''
  },
  title: {
    isError: false,
    message: ''
  },
  onclick_id: {
    isError: false,
    message: ''
  }
}

const FormAdjustNotification = ({ onCloseForm, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false)
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [selectedUploadImage, setSelectedUploadImage] = useState('')
  const [fileImage, setFileImage] = useState(null)
  // product state
  const [loadingProduct, setLoadingProduct] = useState(true)
  const [searchProduct, setSearchProduct] = useState('')
  const [productList, setProductList] = useState([])
  // brand state
  const [loadingBrand, setLoadingBrand] = useState(true)
  const [searchBrand, setSearchBrand] = useState('')
  const [brandList, setBrandList] = useState([])
  // supplier state
  const [loadingSupplier, setLoadingSupplier] = useState(true)
  const [searchSupplier, setSearchSupplier] = useState('')
  const [supplierList, setSupplierList] = useState([])
  // user state
  const [selectedUser, setSelectedUser] = useState(false)
  const [loadingUsers, setLoadingUsers] = useState(true)
  const [searchUser, setSearchUser] = useState('')
  const [userList, setUserList] = useState([])
  const [selectedUserId, setSelectedUserId] = useState(null)
  // country state
  const [selectedCountry, setSelectedCountry] = useState(false)
  const [loadingCountry, setLoadingCountry] = useState(true)
  const [countryList, setCountryList] = useState([])
  const [selectedCountryId, setSelectedCountryId] = useState([])
  // role state
  const [selectedRole, setSelectedRole] = useState(false)
  const [loadingRole, setLoadingRole] = useState(true)
  const [roleList, setRoleList] = useState([])
  const [selectedRoleId, setSelectedRoleId] = useState([])
  // category state
  const [categoryLvl1, setCategoryLvl1] = useState(null)
  const [categoryLvl2, setCategoryLvl2] = useState(null)
  const [categoryLvl3, setCategoryLvl3] = useState(null)
  const [categoryLvl1List, setCategoryLvl1List] = useState([])
  const [categoryLvl2List, setCategoryLvl2List] = useState([])
  const [categoryLvl3List, setCategoryLvl3List] = useState([])
  const [loadingCategoryLvl1, setLoadingCategoryLvl1] = useState(false)
  const [loadingCategoryLvl2, setLoadingCategoryLvl2] = useState(false)
  const [loadingCategoryLvl3, setLoadingCategoryLvl3] = useState(false)

  const submitNotification = async () => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let validateForm = {}
    if (formData.label === 'info') {
      validateForm = {
        label: formData.label,
        title: formData.title,
      }
      delete validationForm.onclick_id
    } else {
      validateForm = {
        label: formData.label,
        title: formData.title,
        onclick_id: formData.onclick_id,
      }
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const countryIds = selectedCountryId.map((val) => Number(val))
    const roleIds = selectedRoleId.map((val) => Number(val))
    const payload = {
      label: formData.label,
      title: formData.title,
      notes: formData.notes,
      recipient: selectedUserId === null ? 'all members' : Number(selectedUserId),
      country_sign_up: countryIds,
      roles: roleIds,
    }
    if (formData.label === 'info') {
      if (formData.onclick_url && formData.onclick_url !== '') {
        payload.onclick_url = formData.onclick_url
      }
    } else {
      payload.onclick_id = formData.onclick_id
    }
    if (selectedUploadImage === 'upload') {
      payload.image_encoded = fileImage
    } else if (selectedUploadImage === 'url') {
      payload.image = fileImage
    } else {
      payload.image = ''
    }
    try {
      const response = await addAdminNews(payload)
      if (response.success) {
        notificationSuccess('Add Notification Successfully', 'You have been added new notification')
        onCloseForm()
        reloadList()
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Add Notification Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const getCategoriesLvl1 = useDebouncedCallback(async () => {
    setLoadingCategoryLvl1(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'filter[level][is]': 1,
      'fields[category]': 'name,image',
    }
    try {
      const response = await getCategorysList(parameter)
      const dataCategories = response.data.data
      const remapDataCategories = dataCategories.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          image: val.attributes.image,
        }
      })
      setCategoryLvl1List(remapDataCategories)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCategoryLvl1(false)
    }
  }, 300)

  const getCategoriesLvl2 = useDebouncedCallback(async (categoryIdLvl1) => {
    setLoadingCategoryLvl2(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'filter[parent_id][is]': categoryIdLvl1,
      'fields[category]': 'name,image',
    }
    try {
      const response = await getCategorysList(parameter)
      const dataCategories = response.data.data
      const remapDataCategories = dataCategories.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          image: val.attributes.image,
        }
      })
      setCategoryLvl2List(remapDataCategories)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCategoryLvl2(false)
    }
  }, 300)

  const getCategoriesLvl3 = useDebouncedCallback(async (categoryIdLvl2) => {
    setLoadingCategoryLvl3(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'filter[parent_id][is]': categoryIdLvl2,
      'fields[category]': 'name,image',
    }
    try {
      const response = await getCategorysList(parameter)
      const dataCategories = response.data.data
      const remapDataCategories = dataCategories.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          image: val.attributes.image,
        }
      })
      setCategoryLvl3List(remapDataCategories)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCategoryLvl3(false)
    }
  }, 300)


  const handleGetListProduct = useDebouncedCallback(async () => {
    setLoadingProduct(true)
    const parameter = {
      'filter[title][like]': searchProduct,
      'page[num]': 1,
      'page[limit]': 15,
    }
    try {
      const response = await getAllProductsList(parameter)
      const responseProduct = response.data
      const remapDataProduct = responseProduct.map((val) => {
        return {
          label: val.attributes.title,
          value: `${val.attributes.id}`,
          image: val.attributes.image
        }
      })
      setProductList(remapDataProduct)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingProduct(false)
    }
  }, 300)

  const handleGetListBrand = useDebouncedCallback(async () => {
    setLoadingBrand(true)
    const parameter = {
      'filter[name][like]': searchBrand,
      'page[num]': 1,
      'page[limit]': 15,
    }

    try {
      const response = await getAllBrandList(parameter)
      const dataBrands = response.data
      const remapDataBrands = dataBrands.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setBrandList(remapDataBrands)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingBrand(false)
    }
  }, 300)

  const handleGetListSupplier = useDebouncedCallback(async () => {
    setLoadingSupplier(true)
    const parameter = {
      'filter[name][like]': searchSupplier,
      'page[num]': 1,
      'page[limit]': 15,
      'fields[supplier]': 'name'
    }

    try {
      const response = await getAllSupplierList(parameter)
      const dataSuppliers = response.data
      const remapDataSuppliers = dataSuppliers.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setSupplierList(remapDataSuppliers)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSupplier(false)
    }
  }, 300)

  const handleGetUsers = useDebouncedCallback(async () => {
    setLoadingUsers(true)
    const parameter = {
      'filter[name][like]': searchUser,
      'page[num]': 1,
      'page[limit]': 15,
    }
    try {
      const response = await getListUsers(parameter)
      const { data } = response.data
      const remap = data.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
        }
      })
      setUserList(remap)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingUsers(false)
    }
  }, 300)

  const handleGetListCountry = useDebouncedCallback(async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }, 300)

  const handleGetListUserRole = useDebouncedCallback(async () => {
    setLoadingRole(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'fields[supplier]': 'name',
    }
    try {
      const response = await getListUserMemberships(parameter)
      const dataUserRoles = response.data.data
      const remapDataUserRoles = dataUserRoles.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setRoleList(remapDataUserRoles)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingRole(false)
    }
  }, 300)

  useEffect(() => {
    handleGetListProduct()
    // eslint-disable-next-line
  }, [searchProduct])

  useEffect(() => {
    handleGetListBrand()
    // eslint-disable-next-line
  }, [searchBrand])

  useEffect(() => {
    handleGetListSupplier()
    // eslint-disable-next-line
  }, [searchSupplier])

  useEffect(() => {
    if (selectedUser) {
      handleGetUsers()
    } else {
      setSelectedUserId(null)
    }
    // eslint-disable-next-line
  }, [searchUser, selectedUser])

  useEffect(() => {
    if (selectedCountry) {
      handleGetListCountry()
    } else {
      setSelectedCountryId([])
    }
    // eslint-disable-next-line
  }, [selectedCountry])

  useEffect(() => {
    if (selectedRole) {
      handleGetListUserRole()
    } else {
      setSelectedRoleId([])
    }
    // eslint-disable-next-line
  }, [selectedRole])

  useEffect(() => {
    if (formData.label === 'category') {
      getCategoriesLvl1()
    }
    // eslint-disable-next-line
  }, [formData.label])

  useEffect(() => {
    setValidationForm(formValidation)
  }, [])

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleUploadImage = (file) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      setFileImage(reader.target.result)
    }
  }

  const handleErrorFile = (file) => {
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      notificationError('Upload Notification Image Error', `${errorMessage}`)
    }
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const mappingFormTypeNotification = (label) => {
    if (label === 'info') {
      return (
        <TextInput
          name='onclick_url'
          value={formData.onclick_url}
          label='URL'
          placeholder='ex. https://asiacommerce.net/'
          onChange={(val) => handleChangeForm('onclick_url', val.target.value)}
          size='xs'
        />
      )
    } else if (label === 'product') {
      const renderProductOption = ({ option }) => {
        return (
          <Group justify='space-between' align='center' gap="xs">
            <Flex gap='sm' align='center'>
              <Paper shadow="sm" w={32} withBorder radius='md'>
                <Image w={30} h={30} radius='md' src={option.image} />
              </Paper>
              <Box>
                <Text fz={10} fw='600' lineClamp={2}>{option.label}</Text>
              </Box>
            </Flex>
          </Group>
        )
      }

      return (
        <Select
          name='onclick_id'
          value={formData.onclick_id}
          label='Product Name'
          data={productList}
          onChange={(val) => handleChangeForm('onclick_id', val)}
          error={validationForm.onclick_id.isError ? `${validationForm.onclick_id.message}` : ''}
          size='xs'
          searchable
          renderOption={renderProductOption}
          searchValue={searchProduct}
          onSearchChange={setSearchProduct}
          nothingFoundMessage={!loadingProduct ? productList.length > 0 ? '' : 'No Product Found' : loadingDataTemplate()}
          clearable
          allowDeselect={false}
          withAsterisk
        />
      )
    } else if (label === 'brand') {
      return (
        <Select
          name='onclick_id'
          value={formData.onclick_id}
          label='Brand Name'
          data={brandList}
          onChange={(val) => handleChangeForm('onclick_id', val)}
          error={validationForm.onclick_id.isError ? `${validationForm.onclick_id.message}` : ''}
          size='xs'
          searchable
          searchValue={searchBrand}
          onSearchChange={setSearchBrand}
          nothingFoundMessage={!loadingBrand ? brandList.length > 0 ? '' : 'No Brand Found' : loadingDataTemplate()}
          clearable
          allowDeselect={false}
          withAsterisk
        />
      )
    } else if (label === 'supplier') {
      return (
        <Select
          name='onclick_id'
          value={formData.onclick_id}
          label='Supplier Name'
          data={supplierList}
          onChange={(val) => handleChangeForm('onclick_id', val)}
          error={validationForm.onclick_id.isError ? `${validationForm.onclick_id.message}` : ''}
          size='xs'
          searchable
          searchValue={searchSupplier}
          onSearchChange={setSearchSupplier}
          nothingFoundMessage={!loadingSupplier ? supplierList.length > 0 ? '' : 'No Supplier Found' : loadingDataTemplate()}
          clearable
          allowDeselect={false}
          withAsterisk
        />
      )
    } else if (label === 'category') {
      const renderCategoryOption = ({ option }) => {
        return (
          <Group justify='space-between' align='center' gap="xs">
            <Flex gap='sm' align='center'>
              <Paper shadow="sm" w={32} withBorder radius='md'>
                <Image w={30} h={30} radius='md' src={option.image} />
              </Paper>
              <Box>
                <Text fz={10} fw='600' lineClamp={2}>{option.label}</Text>
              </Box>
            </Flex>
          </Group>
        )
      }

      return (
        <Fieldset legend={<Text fz='xs' fw='600'>Category</Text>}>
          <Box mb='sm'>
            <Select
              name='categoryLvl1'
              value={categoryLvl1}
              label='Category Level 1'
              data={categoryLvl1List}
              onChange={(val) => [setCategoryLvl1(val), setCategoryLvl2(null), setCategoryLvl3(null), handleChangeForm('onclick_id', val), getCategoriesLvl2(val)]}
              size='xs'
              nothingFoundMessage={!loadingCategoryLvl1 ? categoryLvl1List.length > 0 ? '' : 'No Category Found' : loadingDataTemplate()}
              allowDeselect={false}
              renderOption={renderCategoryOption}
              withAsterisk
              error={validationForm.onclick_id.isError ? `${validationForm.onclick_id.message}` : ''}
            />
          </Box>
          <Box mb='sm'>
            <Select
              name='categoryLvl2'
              value={categoryLvl2}
              label='Category Level 2'
              data={categoryLvl2List}
              onChange={(val) => [setCategoryLvl2(val), setCategoryLvl3(null), handleChangeForm('onclick_id', val), getCategoriesLvl3(val)]}
              size='xs'
              nothingFoundMessage={!loadingCategoryLvl2 ? categoryLvl2List.length > 0 ? '' : 'No Category Found' : loadingDataTemplate()}
              allowDeselect={false}
              clearable
              disabled={categoryLvl1 === null}
              renderOption={renderCategoryOption}
              withAsterisk
              error={validationForm.onclick_id.isError ? `${validationForm.onclick_id.message}` : ''}
            />
          </Box>
          <Box mb='sm'>
            <Select
              name='categoryLvl3'
              value={categoryLvl3}
              label='Category Level 3'
              data={categoryLvl3List}
              onChange={(val) => [setCategoryLvl3(val), handleChangeForm('onclick_id', val)]}
              size='xs'
              nothingFoundMessage={!loadingCategoryLvl3 ? categoryLvl3List.length > 0 ? '' : 'No Category Found' : loadingDataTemplate()}
              allowDeselect={false}
              clearable
              disabled={categoryLvl2 === null}
              renderOption={renderCategoryOption}
              withAsterisk
              error={validationForm.onclick_id.isError ? `${validationForm.onclick_id.message}` : ''}
            />
          </Box>
        </Fieldset>
      )
    }
  }

  const mappingFormUploadImage = (typeUpload) => {
    if (typeUpload === 'url') {
      return (
        <TextInput
          name='fileImage'
          value={fileImage}
          label='Image URL'
          onChange={(val) => setFileImage(val.target.value)}
          withAsterisk
          size='xs'
        />
      )
    } else if (typeUpload === 'upload') {
      if (fileImage === null) {
        return (
          <Input.Wrapper label='Upload Notification Image' size='xs' withAsterisk>
            <Box>
              <Dropzone
                h={200}
                accept={[
                  'image/png',
                  'image/jpeg',
                  'image/gif',
                ]}
                onDrop={(files) => handleUploadImage(files)}
                onReject={(files) => handleErrorFile(files)}
                maxSize={2000000}
              >
                <Box ta='center' my={40}>
                  <Center h={40}>
                    <IconPhotoPlus size={24} color='gray' />
                  </Center>
                  <Box>
                    <Text fz={12} c='blue.9'>Upload Image Here</Text>
                    <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 2 MB</Text>
                  </Box>
                </Box>
              </Dropzone>
            </Box>
          </Input.Wrapper>
        )
      } else {
        return (
          <Box my={10}>
            <Text fz={12} my={5} fw='500'>Preview Upload Notification Image</Text>
            <Center h={200} w='auto' pos='relative' my={8} style={{ backgroundColor: '#f8f9fa', border: '1px dashed #ced4da' }}>
              <Paper >
                <Image src={fileImage} w='auto' radius='md' h={200} fit='cover' />
              </Paper>
            </Center>
            <Flex justify='end' my={10}>
              <Button size='compact-xs' onClick={() => setFileImage(null)}>Remove Image</Button>
            </Flex>
          </Box>
        )
      }
    }
  }

  return (
    <Box>
      <Box mb='sm'>
        <Select
          name='label'
          value={formData.label}
          label='Type Notification'
          data={defaultTypeNotification}
          onChange={(val) => [handleChangeForm('label', val), handleChangeForm('onclick_id', null), setCategoryLvl1(null), setCategoryLvl2(null), setCategoryLvl3(null)]}
          error={validationForm.label.isError ? `${validationForm.label.message}` : ''}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        {mappingFormTypeNotification(formData.label)}
      </Box>
      <Box mb='sm'>
        <TextInput
          name='title'
          value={formData.title}
          label='Title Notification'
          placeholder="Input title"
          error={validationForm.title.isError ? `${validationForm.title.message}` : ''}
          onChange={(val) => handleChangeForm('title', val.target.value)}
          withAsterisk
          size='xs'
        />
      </Box>
      <Box my='sm'>
        <Textarea
          name='notes'
          label="Additional Notes"
          placeholder="Input additional notes"
          value={formData.notes}
          onChange={(val) => handleChangeForm('notes', val.target.value)}
          size='xs'
          autosize
          minRows={4}
          maxRows={4}
        />
      </Box>
      <Box mb='sm'>
        <Select
          name='selectedUploadImage'
          value={selectedUploadImage}
          label='Type Upload Notification Image'
          data={defaultTypeImageNotification}
          onChange={(val) => [setSelectedUploadImage(val), setFileImage(null)]}
          size='xs'
          allowDeselect={false}
        />
      </Box>
      <Box mb='sm'>
        {mappingFormUploadImage(selectedUploadImage)}
      </Box>
      <Box mb='sm'>
        <Checkbox
          label="Notify to specified user"
          onChange={(event) => [setSelectedUser(event.currentTarget.checked), setSelectedCountry(false), setSelectedRole(false)]}
          size='xs'
          mb={4}
          disabled={selectedCountry || selectedRole}
        />
        <Box>
          {selectedUser && (
            <Select
              name='selectedUserId'
              value={selectedUserId}
              label='Choose User'
              data={userList}
              onChange={(val) => setSelectedUserId(val)}
              size='xs'
              searchable
              searchValue={searchUser}
              onSearchChange={setSearchUser}
              nothingFoundMessage={!loadingUsers ? userList.length > 0 ? '' : 'No User Found' : loadingDataTemplate()}
              clearable
              mb='sm'
            />
          )}
        </Box>
      </Box>
      <Box mb='sm'>
        <Checkbox
          label="Notify to specified country signup"
          onChange={(event) => [setSelectedCountry(event.currentTarget.checked), setSelectedUser(false)]}
          size='xs'
          mb={4}
          disabled={selectedUser}
        />
        <Box>
          {selectedCountry && (
            <MultiSelect
              name='selectedCountryId'
              value={selectedCountryId}
              label='Choose Country Signup'
              data={countryList}
              onChange={(val) => setSelectedCountryId(val)}
              size='xs'
              searchable
              nothingFoundMessage={!loadingCountry ? countryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
              clearable
              mb='sm'
            />
          )}
        </Box>
      </Box>
      <Box mb='sm'>
        <Checkbox
          label="Notify to specified role user"
          onChange={(event) => [setSelectedRole(event.currentTarget.checked), setSelectedUser(false)]}
          size='xs'
          mb={4}
          disabled={selectedUser}
        />
        <Box>
          {selectedRole && (
            <MultiSelect
              name='selectedRoleId'
              value={selectedRoleId}
              label='Choose Role User'
              data={roleList}
              onChange={(val) => setSelectedRoleId(val)}
              size='xs'
              searchable
              nothingFoundMessage={!loadingRole ? roleList.length > 0 ? '' : 'No User Role Found' : loadingDataTemplate()}
              clearable
              mb='sm'
            />
          )}
        </Box>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitNotification()}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustNotification